<template>
  <v-card height="100%">
    <v-card-title>
      Contact Information
      <v-spacer></v-spacer>
      <v-img
        max-height="50"
        max-width="50"
        :src="user.avatarImage"
      ></v-img>
    </v-card-title>

    <v-card-subtitle v-if="!profile.complete" class="red--text text-bold">
      You have not completed your profile! You will not be able to make any share purchases until your profile is complete.
    </v-card-subtitle>

    <v-card-text>
      <v-list-item v-if="user.firstName && user.lastName">
        <v-list-item-content>
          <v-list-item-title>Name</v-list-item-title>
          <v-list-item-subtitle>{{ user.firstName }} {{ user.lastName }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            Email Address
            <v-icon
              small
              color="green"
            >
              mdi-check-bold
            </v-icon>
          </v-list-item-title>
          <v-list-item-subtitle>{{ user.emailAddress }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="profile.phoneNumber">
        <v-list-item-content>
          <v-list-item-title>
            Phone Number
            <v-icon
              small
              color="green"
            >
              mdi-check-bold
            </v-icon>
          </v-list-item-title>
          <v-list-item-subtitle>{{ profile.phoneNumber }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            Physical Address
            <v-icon
              v-if="profile.addressLine1"
              small
              color="green"
            >
              mdi-check-bold
            </v-icon>
            <v-icon
              v-else
              small
              color="error"
            >
              mdi-alert-circle
            </v-icon>
          </v-list-item-title>
          <v-list-item-subtitle v-if="profile.addressLine1">
            <div>{{ profile.addressLine1 }}</div>
            <div v-if="profile.addressLine2">{{ profile.addressLine2 }}</div>
            <div>{{ profile.addressCity }}, {{ profile.addressState }} {{ profile.addressPostalCode }}</div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            Identity Information
            <v-icon
              v-if="profile.complete"
              small
              color="green"
            >
              mdi-check-bold
            </v-icon>
            <v-icon
              v-else
              small
              color="error"
            >
              mdi-alert-circle
            </v-icon>
          </v-list-item-title>
          <v-list-item-subtitle  v-if="profile.complete">●●● - ●● - ●●●●</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-dialog
        v-model="profileEdit"
        max-width="500px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Update Profile
          </v-btn>
        </template>
        <ProfileForm
          v-on:dialog-close="profileEdit = false"
        ></ProfileForm>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ProfileForm from './ProfileForm.vue'

  export default {
    name: 'AccountDetails',

    components: {
      ProfileForm
    },

    computed: {
      ...mapGetters([
        'user',
        'profile'
      ])
    },

    data: () => ({
      profileEdit: false
    })
  }
</script>
